module.exports = __webpack_public_path__ + "../resources/images/illustration_archive-4fc6ee4cc818adf3fc496c890fdc0919.svg";